import React from "react";
import { Modal, Button } from "antd";

const LogoutUserModal = ({ open, user, onCancel, onConfirm }) => {
  return (
    <Modal
      title="Logout User"
      open={open}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="logout" type="primary" danger onClick={onConfirm}>
          Logout
        </Button>,
      ]}
    >
      {user && (
        <div>
          This will sign out <strong>{user.name}</strong> from all active sessions.
        </div>
      )}
    </Modal>
  );
};

export default LogoutUserModal;


